import { Injectable } from '@angular/core';

import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { CurrentUserSelectors } from '@recruitee/account-data';
import {
  AccountBase,
  filterBoolean,
  SentryCurrentAdmin,
  SentryCurrentCompany,
} from '@recruitee/common';

import { AccountSelectors } from '../store/account.state';

@Injectable({ providedIn: 'root' })
export class ErrorHandlerAccountService extends AccountBase {
  public currentAdmin$: Observable<SentryCurrentAdmin> = this.store
    .select(CurrentUserSelectors.data)
    .pipe(filterBoolean);
  public currentCompany$: Observable<SentryCurrentCompany> = this.store
    .select(AccountSelectors.currentCompany)
    .pipe(filterBoolean);

  constructor(private store: Store) {
    super();
  }
}
